module.exports = __webpack_public_path__ + "img/商城海报.d9ffb618.jpg";